module.exports = __webpack_public_path__ + "img/1334736440.95eaf2c9.jpg";